import Image from "next/image";

import { Plus } from "lucide-react";
import type { Control, FieldValues, Path } from "react-hook-form";

import closePromoCodeIcon from "@repo/ui/assets/icons/promo-code-close.svg";
import { Button } from "@repo/ui/components/ui/button";
import { InputField } from "@repo/ui/FormFields/InputField";

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  showPromoCode: boolean;
  promoCode?: string;
  buttonLabel: string;
  handleFieldIconCallback: () => void;
  handleShowPromoCode: (value: boolean) => void;
};

export default function PromoCode<T extends FieldValues>({
  control,
  name,
  showPromoCode,
  promoCode,
  buttonLabel,
  handleFieldIconCallback,
  handleShowPromoCode,
}: Props<T>) {
  return showPromoCode || promoCode ? (
    <div className="animate-in fade-in-0 flex w-full duration-200">
      <InputField
        control={control}
        name={name}
        placeholder="Código promocional"
        className="flex-1 block w-full bg-white"
        inputClassName="border-[#7D93B2] shadow-[0px_0px_0px_2px_#BFDEFF] hover:border-[#7D93B2]"
        handleFieldIconCallback={handleFieldIconCallback}
        icon={<Image src={closePromoCodeIcon} alt="Close" width={16} height={16} />}
        maxLength={8}
      />
    </div>
  ) : (
    <div className="flex flex-1 w-full">
      <Button
        variant="ghost"
        className="hover:text-brand-cyan w-full cursor-pointer gap-0 !p-0 !leading-none transition-none hover:bg-transparent whitespace-normal"
        onClick={() => handleShowPromoCode(true)}
        type="button"
        data-testid="add-promo-code-btn"
      >
        <Plus />
        <span className="flex-1 ml-2 text-left text-[13px] md:text-base">{buttonLabel}</span>
      </Button>
    </div>
  );
}
